/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Nice_To_HaveInputs */

const en_jobs_nice_to_have = /** @type {(inputs: Jobs_Nice_To_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nice to Have`)
};

const de_jobs_nice_to_have = /** @type {(inputs: Jobs_Nice_To_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wünschenswert`)
};

const fr_jobs_nice_to_have = /** @type {(inputs: Jobs_Nice_To_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souhaitable`)
};

const es_jobs_nice_to_have = /** @type {(inputs: Jobs_Nice_To_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deseable`)
};

const it_jobs_nice_to_have = /** @type {(inputs: Jobs_Nice_To_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requisiti graditi`)
};

const nl_jobs_nice_to_have = /** @type {(inputs: Jobs_Nice_To_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mooi meegenomen`)
};

const pl_jobs_nice_to_have = /** @type {(inputs: Jobs_Nice_To_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mile widziane`)
};

const fi_jobs_nice_to_have = /** @type {(inputs: Jobs_Nice_To_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyödyllistä`)
};

const da_jobs_nice_to_have = /** @type {(inputs: Jobs_Nice_To_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godt at have`)
};

const sv_jobs_nice_to_have = /** @type {(inputs: Jobs_Nice_To_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bra att ha`)
};

/**
* | output |
* | --- |
* | "Nice to Have" |
*
* @param {Jobs_Nice_To_HaveInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_nice_to_have = /** @type {((inputs?: Jobs_Nice_To_HaveInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Nice_To_HaveInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_nice_to_have(inputs)
	if (locale === "fr") return fr_jobs_nice_to_have(inputs)
	if (locale === "es") return es_jobs_nice_to_have(inputs)
	if (locale === "it") return it_jobs_nice_to_have(inputs)
	if (locale === "nl") return nl_jobs_nice_to_have(inputs)
	if (locale === "pl") return pl_jobs_nice_to_have(inputs)
	if (locale === "fi") return fi_jobs_nice_to_have(inputs)
	if (locale === "da") return da_jobs_nice_to_have(inputs)
	if (locale === "sv") return sv_jobs_nice_to_have(inputs)
	return en_jobs_nice_to_have(inputs)
});